import Select from "../../select";
import { SelectControlProps, SelectGroup, SelectOption } from "../types";
import { parseChange, parseOptions, parseValue } from "../utils";

export default function SelectControl<
  Option extends SelectOption = SelectOption,
  IsMulti extends boolean = boolean,
  Group extends SelectGroup<Option> = SelectGroup<Option>,
>(props: Readonly<Omit<SelectControlProps<Option, IsMulti, Group>, "type">>) {
  const { isMulti = false } = props;
  const {
    value,
    options = [],
    showInvalid,
    onChange,
    getInputRef,
    onRemove,
    ...rest
  } = props;

  const parsedOptions = showInvalid
    ? parseOptions(value, options, isMulti)
    : options;
  const parsedValue = parseValue(value, parsedOptions, isMulti);

  return (
    <Select<Option, IsMulti, Group>
      {...rest}
      value={parsedValue}
      options={parsedOptions}
      getInputRef={getInputRef}
      onChange={(e) => onChange?.(parseChange(e, isMulti))}
      onDelete={onRemove ? (o) => onRemove(o.id) : undefined}
    />
  );
}
